/**
 * @generated SignedSource<<2386bf776c4cfa93e1f79e8dfbc126c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardFlightsCard_flightsInfo$data = {
  readonly total: number;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsCardUpdateStatus_flightsInfo">;
  readonly " $fragmentType": "DashboardFlightsCard_flightsInfo";
};
export type DashboardFlightsCard_flightsInfo$key = {
  readonly " $data"?: DashboardFlightsCard_flightsInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsCard_flightsInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardFlightsCard_flightsInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DashboardFlightsCardUpdateStatus_flightsInfo"
    }
  ],
  "type": "DashboardFlightsInfo",
  "abstractKey": null
};

(node as any).hash = "200fab0502f44b3cc10db97bd2da0eb3";

export default node;
